import React from 'react'
import {history} from "../../configureHistory";
import {t} from '../../i18n';
import {orderStatuses} from "../constants/orderStatuses";
import {ai} from "../../TelemetryService";
import image from "../Resourses/check.png";
import {useStore} from "react-redux";

export default () => {
  const state: any = history.location.state;
  //window.history.replaceState(null, '', `/${state.data.LinkCode}`);
    let styles: any = useStore().getState().globalReducer.styles;
    // @ts-ignore
    let pageType = (state && state.pageType) || 0;

  const mainText = () => {
      if (state) {
        const status = +state.OrderStatus;
        ai.appInsights.trackEvent({ name: 'Order status: ' + status });
        if (status == orderStatuses.Canceled || status == orderStatuses.Rejected) {
          return t("OrderCanceled_TextAtTheBottom");
        } else if (status == orderStatuses.Removed) {
          return t("OrderRemoved_TextAtTheBottom");
        } else if (status == orderStatuses.Delivered ||
          status == orderStatuses.DeliverdWithDeviation ||
          status == orderStatuses.DeliveredLocker) {
          if (pageType == 1) {
            return t("SuccessfulDeliveryWhenOrderWasDeliveredEarlier_TextAtTheBottom");
          }
          else {
            return t("SuccessfulDelivery_TextAtTheBottom");
          }
        } else {
          return t("OrderNotReadyForDelivery_TextUnderCommonText");
        }
      }
    };

  const showTryAgainText = () => {
      if (state) {
        const status = +state.OrderStatus;
        if (status != orderStatuses.Canceled &&
          status != orderStatuses.Removed &&
          status != orderStatuses.Rejected &&
          status != orderStatuses.Delivered &&
          status != orderStatuses.DeliverdWithDeviation &&
          status != orderStatuses.DeliveredLocker) {
          return true;
        }
      }
    };

    const imageStyles = {
        height: '150px',
        maxHeight: '150px',
        width: 'auto'
    };

    let styleCommon = {
        overflowWrap:"anywhere",
        fontFamily: styles.CommonSettings.FontFamily,
        color: styles.CommonSettings.FontColor
    } as React.CSSProperties;

    const showImage = () => {
        let style = styles.SuccessfulDelivery;
        if (pageType == 1) {
            style = styles.SuccessfulDeliveryWhenOrderWasDeliveredEarlier;
        }
      if (state) {
        const status = +state.OrderStatus;
        if (status == orderStatuses.Delivered ||
          status == orderStatuses.DeliverdWithDeviation ||
          status == orderStatuses.DeliveredLocker) {

          if (style.Show && style.UseCustom) {
            return <img style={imageStyles} src={String(style.Image)} />;
          } else if (style.Show && !style.UseCustom) {
            return <img src={image} alt="Check" />
          }
        }
      }
    };

    return (
        <div>
            <div className="container text-center">
                <div className="row">
                    <div className="col-12" style={styleCommon}>
                        <p>{t("CommonText_FirstLine")}</p>
                        <h3>{t("CommonText_SecondLine")}</h3>
                    </div>
                </div>
                <div className="row justify-content-md-center">
                    <div className="col-md-auto">
                        {showImage()}
                        <h3 style={styleCommon}>{mainText()}</h3>
                    </div>
                </div>
                <div className="row justify-content-md-center">
                    <div className="col-md-auto">
                        <h3 style={styleCommon}>{showTryAgainText() && t("OrderNotReadyForDelivery_TextAtTheBottom")}</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}
